"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _WhiteListedAddressesListComponent = _interopRequireDefault(require("./WhiteListedAddressesListComponent"));
var _eotcWithdrawActions = require("../../redux/actions/eotcWithdrawActions");
var _depositWithdrawalSelectors = require("../../redux/selectors/depositWithdrawalSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ownProps) {
  var productId = (0, _lodash.get)(state, 'apexCore.position.selectedProductId', null);
  var verificationLevelConfig = (0, _lodash.get)(state, ['user', 'verificationLevelConfigs', 'Products'], []).find(function (i) {
    return i.ProductId === productId;
  }) || {};
  return {
    whiteListedAddresses: (0, _depositWithdrawalSelectors.whiteListedAddressesSelector)(state),
    verificationLevelConfig: verificationLevelConfig,
    hideHeader: true,
    ProductId: productId
  };
};
var mapDispatchToProps = {
  DeleteAccountWithdrawInfo: _eotcWithdrawActions.DeleteAccountWithdrawInfo
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WhiteListedAddressesListComponent["default"]);